import React, {Component} from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
//import { PasswordForgetForm } from './PasswordForget';
//import PasswordChangeForm from './PasswordChange';
import withAuthorization from '../../withAuthorization';
import Subscription from './Subscription'
// import { watchNotificationTopics } from '../../actions/asyncEventsAction'
//import Typography from '@material-ui/core/Typography';
  import Grid from '@material-ui/core/Grid';
  import { withStyles } from '@material-ui/core/styles';
//import classNames from 'classnames'
import Headline from '../../../Container/Headlines/PageHeadline'
import UserProfile from './UserProfile'
import PasswordActions from './PasswordActions'
import {accountGridSettings} from '../../../js/settings/grid'
import { isIOS } from 'react-device-detect'
//import _ from 'lodash'

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: '1em',
    marginBottom: '1em',
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  avatar: {
    margin: 10,
    marginLeft: '28%'
  },
  bigAvatar: {
    width: 100,
    height:100,
    backgroundColor: 'grey',
  },
  card: {
    maxWidth: 320,
    marginBottom: theme.spacing.unit*1,
    padding: 8,
    borderBottom: '1px solid #3f51b5'
  },
})

class AccountPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userData: null,
    };
  }
  
  componentDidMount() {
  //  if(this.props.authUser.uid)
   // this.props.watchSubscirptions(this.props.authUser.uid)
  }
  
  render() {
    const {userData, classes} = this.props
    return (
      <div className={classes.root}>
      <Headline headline='Benuterkonto' subtext={null} />
      <Grid container {...accountGridSettings.container}>
        <Grid item {...accountGridSettings.breakPoints} >
          <UserProfile userData={userData} />
        </Grid>
        {isIOS
          ? null
          : (<Grid item {...accountGridSettings.breakPoints} > 
            <Subscription />
        </Grid>)}
        <Grid item {...accountGridSettings.breakPoints} >
          <PasswordActions />
        </Grid>
      </Grid>
      </div>
    )
  }
}




const mapStateToProps = (state) => {
  return ({
  authUser: state.sessionState.authUser,
  userData: state.userState.profile,
  token: state.notificationState.notificationToken
  });
}


const mapDispatchToProps = (dispatch) =>{
  
return ({
 //watchSubscirptions: (userId)=>dispatch(watchNotificationTopics(userId))
})}



  const authCondition = (authUser) => !!authUser;
export default compose(
  withAuthorization(authCondition),
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(AccountPage);



// WEBPACK FOOTER //
// ./src/Components/UserAuth/UserAccount/Account.js